import React from 'react'
import './CheckableButton.css'

// an arbitrary container for use with CheckableButton

function ButtonContainer({
  className,
  label,
  header,
  horizontal,
  vertical,
  superAnn,
  centered,
  twoColumns,
  fixedLabelWidth,
  hidden,
  children,
  iconNextToLabel: IconNextToLabel,
  onIconClick,
  hideChildren,
  ...props
}) {
  let classNameModifier = 'checkable-container'
  if (horizontal) {
    classNameModifier += '-horizontal'
  } else if (vertical) {
    classNameModifier += '-vertical'
  } else if (superAnn) {
    classNameModifier += '-superAnn'
  } else if (twoColumns) {
    if (fixedLabelWidth) {
      classNameModifier += '-fixed'
    }
    classNameModifier += '-columns'
  }

  let containerInner

  if (twoColumns) {
    let subList1 = []
    let subList2 = []
    children.forEach((item, index) => {
      index < children.length / 2 ? subList1.push(item) : subList2.push(item)
    })

    let classesCol1 = ['col-md-6']
    let classesCol2 = ['col-md-6']
    if (vertical) {
      classesCol1.push('first-col-vertical')
      classesCol2.push('second-col-vertical')
    } else {
      classesCol1.push('timetable_sectionwidth')
      classesCol2.push('timetable_sectionwidth')
    }

    containerInner = (
      <div className='row w-100'>
        <div className={classesCol1.join(' ')}>{subList1}</div>
        <div className={classesCol2.join(' ')}>{subList2}</div>
      </div>
    )
  }

  return (
    <div
      className={
        'checkable-container-outer' +
        (centered ? ' checkable-container-centered' : '') +
        (twoColumns ? ' w-100' : '')
      }
      style={{ display: hidden ? 'none' : 'block' }}
    >
      {label 
        ? <label>
            {label}
            {IconNextToLabel ? <IconNextToLabel onClick={onIconClick} className="button-container-icon-next-to-label" /> : ""}
          </label>
        : ''} 
      {header}

      <div
        {...props}
        className={ hideChildren ? "button-container-children-hidden" :
          classNameModifier + (className ? ' ' + className : '')
        }
      >
        {containerInner || children}
      </div>
    </div>
  )
}

export default ButtonContainer
